// extracted by mini-css-extract-plugin
export default {"anvil-canvas":"styles_anvil-canvas__4-QOj"};